import React from 'react';
import { Router as RouterProvider } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastProvider } from './hooks/toast';
import { Router, history } from './router';
import { IframeProvider } from './contexts/IframeContext';
import './styles/global.css';

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
      <IframeProvider>
        <ToastProvider>
          <RouterProvider history={history}>
            <Router />
          </RouterProvider>
        </ToastProvider>
        <ToastContainer autoClose={4000} position="bottom-left" limit={5} transition={Slide} />
      </IframeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
